import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ['expanded']

  expand() {
    this.element.classList.add(this.expandedClass)
  }
}
